export default __webpack_public_path__ + "ee9b54e32592c74e0fa4a76769f29090.svg";